import useCreateTranslation from './useCreateTranslation'

export default useCreateTranslation
